import { Directive, ElementRef, Renderer2, effect, inject, input } from '@angular/core';

@Directive({
  selector: '[TextHighlight]',
  standalone: true
})
export class TextHighlightDirective {
  private el = inject(ElementRef);
  private renderer = inject(Renderer2);

  readonly searchText = input<string>('');
  readonly content = input<string>('');

  constructor() {
    effect(() => {
      this.highlightFirstOccurrence();
    });
  }

  private highlightFirstOccurrence(): void {
    const searchText = this.searchText();
    const content = this.content();

    if (!searchText || !content) {
      this.renderer.setProperty(this.el.nativeElement, 'innerHTML', content);
      return;
    }

    // Use regex without the global flag to replace only the first match
    const regex = new RegExp(`(${searchText})`, 'i'); // Case-insensitive, non-global
    const highlightedContent = content.replace(
      regex,
      `<span class="search-highlight">$1</span>`
    );

    this.renderer.setProperty(this.el.nativeElement, 'innerHTML', highlightedContent);
  }

}


